<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle3')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <div class="title-line">
      <span>{{ $t('artTitle3-1') }}</span>
      <span>{{ $t('artTitle3-2') }}</span>
    </div>
    <span class="mt-5">{{ $t('artText3-1') }}</span>
    <img
      :src="`${staticUrl}/images/DreamFlat-Home-Design-Software-A-Revolutionizing-Tool.webp`"
      :alt="'altImageDefault'"
    />
    <h2 class="tarifs-block-title">{{ $t('artText3-2') }}</h2>
    <span>{{ $t('artText3-3') }}</span>
    <h2>{{ $t('artText3-4') }}</h2>
    <span>{{ $t('artText3-5') }}</span>
    <ul>
      <li>{{ $t('artText3-5-li-1') }}</li>
      <li>{{ $t('artText3-5-li-2') }}</li>
      <li>{{ $t('artText3-5-li-3') }}</li>
      <li>{{ $t('artText3-5-li-4') }}</li>
    </ul>
    <img
      :src="`${staticUrl}/images/DreamFlat-Home-Design-Software-A-Revolutionizing-Tool-2.webp`"
      :alt="'altImageDefault'"
    />
    <h2 class="mt-0">{{ $t('artText3-6') }}</h2>
    <ul>
      <li>{{ $t('artText3-6-li-1') }}</li>
      <li>{{ $t('artText3-6-li-2') }}</li>
      <li>{{ $t('artText3-6-li-3') }}</li>
      <li>{{ $t('artText3-6-li-4') }}</li>
      <li>{{ $t('artText3-6-li-5') }}</li>
    </ul>
    <span>{{ $t('artText3-7') }}</span>
    <h2>{{ $t('artText3-8') }}</h2>
    <span>{{ $t('artText3-9') }}</span>
    <ul>
      <li>{{ $t('artText3-9-li-1') }}</li>
      <li>{{ $t('artText3-9-li-2') }}</li>
      <li>{{ $t('artText3-9-li-3') }}</li>
      <li>{{ $t('artText3-9-li-4') }}</li>
    </ul>
    <img
      :src="`${staticUrl}/images/DreamFlat-Home-Design-Software-A-Revolutionizing-Tool-1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText3-10') }}</h2>
    <span>{{ $t('artText3-11') }}</span>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle3')}`,
  ogTitle: `${t('artSeoTitle3')}`,
  description: `${t('artSeoDesc3')}`,
  ogDescription: `${t('artSeoDesc3')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
